import React, { useId } from 'react';
import { FAMILY_TIERS } from './recapTiers';
import './RecapTierGroups.css';

/**
 * The recap editors: ONE bordered "Goes home to the family" box holding
 * Everyone and Parents, so what gets emailed is one visible region. Shared by
 * the Recap drawer and the wrap-up sheet so the two cannot drift; each passes
 * `renderTier` because they feed the editor different content (see
 * WrapUpSheet → liveTierContent).
 *
 * TEACHERS ONLY IS GONE FROM HERE (design pass 4 P5.1, 2026-10-05). Teacher
 * writing about a student lives in the Private file (private/PrivateFile.js,
 * the left rail); every Teachers only recap with words was copied there first
 * (scripts/migration/migrateTeacherRecapsToPrivateFile.js, 10 of 10 read back
 * in prod before this shipped). Anthony, 2026-10-05: "remove private recaps
 * from the popup since they live in the left column." The stored `teacher`
 * visibility stays frozen in recapTiers.js: the draft hook still iterates
 * RECAP_TIERS, so an old teacher doc is left exactly as it is, never shown
 * here and never mailed. Removing the field itself is P5.3, a later step.
 */
const RecapTierGroups = ({ renderTier }) => {
	// The drawer and the wrap-up sheet can both be mounted; ids must not collide.
	const titleId = useId();
	return (
		<section className="ld-recaphome" aria-labelledby={titleId}>
			<h3 id={titleId} className="ld-recaphome__title">
				<i className="fa-sharp fa-solid fa-house" aria-hidden="true" />
				Goes home to the family
			</h3>
			<div className="ld-recaphome__tiers">{FAMILY_TIERS.map((tier) => renderTier(tier))}</div>
		</section>
	);
};

export default RecapTierGroups;
